import React, { useMemo } from 'react';

import { bool } from 'prop-types';
import { useSelector } from 'react-redux';

import picsioConfig from '../../../../../config';
import { isRouteProducts } from '../../helpers/history';
import SearchFiltersToriut from './ToriutSearchFilters/index';
import SearchFilters from './SearchFilters';

const SearchFiltersContainer = ({ onlyTextSearch, searchFilters }) => {
  const location = useSelector((state) => state.router.location);

  const isToriutMedia = useMemo(
    () => picsioConfig.isPim && !isRouteProducts(location.pathname),
    [location.pathname],
  );

  return (
    <Choose>
      <When condition={isToriutMedia}>
        <SearchFiltersToriut onlyTextSearch={onlyTextSearch} />
      </When>
      <Otherwise>
        <SearchFilters
          onlyTextSearch={onlyTextSearch}
          searchFilters={searchFilters}
        />
      </Otherwise>
    </Choose>
  );
};

SearchFiltersContainer.propTypes = {
  onlyTextSearch: bool,
  searchFilters: bool,
};

SearchFiltersContainer.defaultProps = {
  onlyTextSearch: false,
  searchFilters: false,
};

export default SearchFiltersContainer;
